const loadRazorpay = () =>
    new Promise((resolve, reject) => {
        if (window.Razorpay) {
            resolve(window.Razorpay);
            return;
        }
        const existing = document.querySelector("script[data-razorpay-checkout]");
        if (existing) {
            existing.addEventListener("load", () => resolve(window.Razorpay));
            existing.addEventListener("error", () => reject(new Error("Could not load the payment window")));
            return;
        }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        script.dataset.razorpayCheckout = "true";
        script.onload = () => resolve(window.Razorpay);
        script.onerror = () => reject(new Error("Could not load the payment window"));
        document.body.appendChild(script);
    });

/**
 * Map POST /payment JSON to Checkout options.
 * Documented fields live on the response root. The Key Id is never returned by the API.
 */
export const readCheckoutFields = (payment) => {
    const source = payment && typeof payment === "object" ? payment : {};
    const nested = source.data && typeof source.data === "object" ? source.data : {};
    return {
        key: String(process.env.REACT_APP_RAZORPAY_KEY_ID || "").trim(),
        orderId: source.order_id || nested.order_id || "",
        currency: source.currency || nested.currency || "INR",
        amountInRupees: source.amount_in_rupees ?? nested.amount_in_rupees ?? null,
        amountPaise: source.amount ?? nested.amount ?? null,
        status: source.status || nested.status || "",
    };
};

export const openRazorpayCheckout = async ({ key, orderId, currency, description, name, email }) => {
    if (!key) {
        throw new Error("Payment could not be started. Add REACT_APP_RAZORPAY_KEY_ID to the app environment.");
    }
    if (!orderId) {
        throw new Error("Payment could not be started. The server did not return an order id.");
    }
    const Razorpay = await loadRazorpay();
    const logoUrl = `${window.location.origin}/images/app-logo.png`;
    return new Promise((resolve, reject) => {
        const checkout = new Razorpay({
            key,
            order_id: orderId,
            currency: currency || "INR",
            name: "Varga Works",
            description: description || "Credit top-up",
            image: logoUrl,
            prefill: { name: name || "", email: email || "" },
            handler: (response) => resolve({
                paymentId: response?.razorpay_payment_id,
                orderId: response?.razorpay_order_id || orderId,
                signature: response?.razorpay_signature,
            }),
            modal: {
                ondismiss: () => reject(new Error("Payment was cancelled")),
            },
        });
        checkout.on("payment.failed", (response) => {
            reject(new Error(response?.error?.description || "Payment failed"));
        });
        checkout.open();
    });
};
